import { render, staticRenderFns } from "./PointCard.vue?vue&type=template&id=b1cf302a&scoped=true&"
import script from "./PointCard.vue?vue&type=script&lang=js&"
export * from "./PointCard.vue?vue&type=script&lang=js&"
import style0 from "./PointCard.vue?vue&type=style&index=0&id=b1cf302a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cf302a",
  null
  
)

export default component.exports